function getCurrentDomain() {
  return `${window.location.hostname}${
    process.env.NODE_ENV === "development" ? ":" + window.location.port : ""
  }`;
}

export default getCurrentDomain;
